// O backend so aceita host terminando em ivienergia.com, e "localhost" nao passa.
const resolverTenantUrl = () => process.env.REACT_APP_TENANT_URL || window.location.hostname;

export { resolverTenantUrl };
